import {Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {IonPopover} from '@ionic/angular';
import { LocalService } from '../../../_services/local.service';
import {Subscription} from 'rxjs';
import {EventiService} from '../../../_services/eventi.service';
import {MovimentiService} from '../../../_services/movimenti.service';
import {AvanzamentoService} from '../../../_services/avanzamento.service';
import {QualitaService} from '../../../_services/qualita.service';
import {SpedizioniService} from '../../../_services/spedizioni.service';
import {AuthenticationService} from '../../../_services/authentication.service';
import {constants} from '../../../_helpers/constants';
import {RisorseService} from '../../../_services/risorse.service';
import {BilanceService} from '../../../_services/bilance.service';
import {OrdinispedizioniService} from "../../../_services/ordinispedizioni.service";
import {QualitaSchedeService} from "../../../_services/qualitaschede.service";
import {LicenzeService} from "../../../_services/licenze.service";
import {LavorazioniService} from "../../../_services/lavorazioni.service";
import {OrdiniSpedizioneBoxService} from "../../../_services/ordinispedizionibox.service";
import {HubMonitorService} from '../../../_services/hub-monitor.service';
import {PianificazioneRealtimeService} from '../../../_services/pianificazione-realtime.service';
import {SaleOrdiniService} from '../../../_services/sale-ordini.service';
import {HubState} from '../../../_models/hub-state';
import {aggregateHubState} from '../../../_helpers/hub-connection.helper';
import {blurActiveOverlayFocus, PopoverBackdropGuard, getPopoverHostElement} from '../../../_helpers/popover-focus-guard';

@Component({
    selector: 'app-hub-state-led',
    templateUrl: './hub-state-led.component.html',
    styleUrls: ['./hub-state-led.component.scss'],
    standalone: false
})
export class HubStateLedComponent implements OnInit, OnDestroy {
  @ViewChild('popover') popover?: IonPopover;
  @ViewChild('triggerButton', {read: ElementRef}) triggerButton?: ElementRef<HTMLElement>;
  /** Stato aggregato mostrato dall'icona grande (verde/arancione/rosso). */
  overallState: number = HubState.Connecting;
  hubState: number = HubState.Connecting;
  hubRisorseState: number = HubState.Connecting;
  hubLavorazioniState: number = HubState.Connecting;
  hubEventiState: number = HubState.Connecting;
  hubMovimentiState: number = HubState.Connecting;
  hubAvanzamentoState: number = HubState.Connecting;
  hubQualitaSchedeState: number = HubState.Connecting;
  hubQualitaState: number = HubState.Connecting;
  hubOrdiniSpedizioniState: number = HubState.Connecting;
  hubOrdiniSpedizioniBoxState: number = HubState.Connecting;
  hubSpedizioniState: number = HubState.Connecting;
  hubBilanceState: number = HubState.Connecting;
  hubAttivitaState: number = HubState.Connecting;
  hubPianificheState: number = HubState.Connecting;
  hubSaleState: number = HubState.Connecting;
  isOpen = false;
  subscription: Subscription;
  private readonly backdropGuard = new PopoverBackdropGuard(
    () => getPopoverHostElement(this.popover),
    () => this.releaseFocus()
  );
  protected readonly constants = constants;
  constructor(
    public authService: AuthenticationService,
    public licenseService: LicenzeService,
    private localService: LocalService,
    private risorseService: RisorseService,
    private lavorazioniService: LavorazioniService,
    private eventiService: EventiService,
    private movimentiService: MovimentiService,
    private avanzamentoService: AvanzamentoService,
    private qualitaSchedeService: QualitaSchedeService,
    private qualitaService: QualitaService,
    private ordiniSpedizioniService: OrdinispedizioniService,
    private ordiniSpedizioniBoxService: OrdiniSpedizioneBoxService,
    private spedizioniService: SpedizioniService,
    private bilanceService: BilanceService,
    private pianificazioneRealtimeService: PianificazioneRealtimeService,
    private saleOrdiniService: SaleOrdiniService,
    private hubMonitorService: HubMonitorService,
    private ngZone: NgZone) { }

  ngOnInit() {
    this.hubState = this.localService.hubState.value;
    this.subscription = this.localService.hubState.subscribe((_hubState: number) => {
        this.applyHubState(() => this.hubState = _hubState);
      });
    this.subscription.add(this.risorseService.hubState.subscribe((_hubState: number) => {
      this.applyHubState(() => this.hubRisorseState = _hubState);
    }));
    this.subscription.add(this.lavorazioniService.hubState.subscribe((_hubState: number) => {
      this.applyHubState(() => this.hubLavorazioniState = _hubState);
    }));
    this.subscription.add(this.eventiService.hubState.subscribe((_hubState: number) => {
      this.applyHubState(() => this.hubEventiState = _hubState);
    }));
    this.subscription.add(this.movimentiService.hubState.subscribe((_hubState: number) => {
      this.applyHubState(() => this.hubMovimentiState = _hubState);
    }));
    this.subscription.add(this.avanzamentoService.hubState.subscribe((_hubState: number) => {
      this.applyHubState(() => this.hubAvanzamentoState = _hubState);
    }));
    this.subscription.add(this.qualitaSchedeService.hubState.subscribe((_hubState: number) => {
      this.applyHubState(() => this.hubQualitaSchedeState = _hubState);
    }));
    this.subscription.add(this.qualitaService.hubState.subscribe((_hubState: number) => {
      this.applyHubState(() => this.hubQualitaState = _hubState);
    }));
    this.subscription.add(this.ordiniSpedizioniService.hubState.subscribe((_hubState: number) => {
      this.applyHubState(() => this.hubOrdiniSpedizioniState = _hubState);
    }));
    this.subscription.add(this.ordiniSpedizioniBoxService.hubState.subscribe((_hubState: number) => {
      this.applyHubState(() => this.hubOrdiniSpedizioniBoxState = _hubState);
    }));
    this.subscription.add(this.spedizioniService.hubState.subscribe((_hubState: number) => {
      this.applyHubState(() => this.hubSpedizioniState = _hubState);
    }));
    this.subscription.add(this.bilanceService.hubState.subscribe((_hubState: number) => {
      this.applyHubState(() => this.hubBilanceState = _hubState);
    }));
    this.subscription.add(this.pianificazioneRealtimeService.attivitaHubState$.subscribe((_hubState: number) => {
      this.applyHubState(() => this.hubAttivitaState = _hubState);
    }));
    this.subscription.add(this.pianificazioneRealtimeService.pianificaHubState$.subscribe((_hubState: number) => {
      this.applyHubState(() => this.hubPianificheState = _hubState);
    }));
    this.subscription.add(this.saleOrdiniService.hubState.subscribe((_hubState: number) => {
      this.applyHubState(() => this.hubSaleState = _hubState);
    }));
    this.subscription.add(this.hubMonitorService.openHubMonitor.subscribe(() => {
      this.applyHubState(() => this.presentPopover());
    }));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.backdropGuard.detach();
  }

  onDidPresent = () => {
    this.backdropGuard.attach();
  };

  onWillClose = () => {
    this.backdropGuard.blurBackdrop();
    this.releaseFocus();
  };

  onClose = () => {
    this.isOpen = false;
    this.backdropGuard.blurBackdrop();
    this.releaseFocus();
  };

  presentPopover(e?: Event) {
    this.releaseFocus(e);

    if (e) {
      this.popover.event = e;
    }
    this.isOpen = true;
  }

  private applyHubState(action: () => void): void {
    this.ngZone.run(() => {
      action();
      this.recomputeOverallState();
    });
  }

  /**
   * Ricalcola lo stato aggregato dell'icona considerando solo gli hub effettivamente visibili
   * (gli stessi gating per licenza delle righe del popover). Non apre il popover: la nuvoletta
   * rossa pulsante è il segnale, il dettaglio si apre al click. L'auto-apertura non è praticabile
   * perché il componente è istanziato per-pagina (Ionic tiene più pagine montate) e aprirebbe
   * popover duplicati/mal posizionati sulle istanze non visibili.
   */
  private recomputeOverallState(): void {
    this.overallState = aggregateHubState(this.collectActiveHubStates());
  }

  private collectActiveHubStates(): number[] {
    const has = (modulo: string) => this.licenseService.checkPermesso(modulo);
    const entries: { state: number; enabled: boolean }[] = [
      {state: this.hubState, enabled: true},
      {state: this.hubRisorseState, enabled: true},
      {state: this.hubLavorazioniState, enabled: true},
      {state: this.hubEventiState, enabled: true},
      {state: this.hubAvanzamentoState, enabled: true},
      {state: this.hubMovimentiState, enabled: has(constants.MOD_PRO_BASE_TRANSFER)},
      {state: this.hubQualitaSchedeState, enabled: has(constants.MOD_QUA_BASE_UI)},
      {state: this.hubQualitaState, enabled: has(constants.MOD_QUA_BASE_UI)},
      {state: this.hubOrdiniSpedizioniState, enabled: has(constants.MOD_SPE_BASE_MAN)},
      {state: this.hubOrdiniSpedizioniBoxState, enabled: has(constants.MOD_SPE_BASE_MAN)},
      {state: this.hubSpedizioniState, enabled: has(constants.MOD_TER_BASE_UI)},
      {state: this.hubBilanceState, enabled: has(constants.MOD_PRO_BASE_BALANCE)},
      {state: this.hubSaleState, enabled: has(constants.MOD_ODV_BASE_UI)},
      {state: this.hubAttivitaState, enabled: has(constants.MOD_PLA_BASE_UI)},
      {state: this.hubPianificheState, enabled: has(constants.MOD_PLA_BASE_UI)},
    ];
    return entries.filter(e => e.enabled).map(e => e.state);
  }

  private releaseFocus(event?: Event): void {
    blurActiveOverlayFocus(event, this.triggerButton?.nativeElement);
  }
}
